/** Formata duração em ms para algo legível: "2.6s", "45s", "1m54s", "> 2h". */
export const formatarDuracao = (durationMs: number | null): string => {
  if (durationMs === null || durationMs === undefined) return '—'

  const totalSegundos = durationMs / 1000

  if (totalSegundos < 60) {
    // abaixo de 10s mostra com 1 casa (ex.: 2.6s); acima, inteiro
    return totalSegundos < 10
      ? `${totalSegundos.toFixed(1)}s`
      : `${Math.round(totalSegundos)}s`
  }

  const minutos = Math.floor(totalSegundos / 60)

  if (minutos < 60) {
    const segundos = Math.round(totalSegundos % 60)
    return segundos > 0 ? `${minutos}m${segundos}s` : `${minutos}m`
  }

  const horas = Math.floor(minutos / 60)
  const minutosRestantes = minutos % 60
  return minutosRestantes > 0 ? `${horas}h${minutosRestantes}m` : `${horas}h`
}

/** Exibe número ou travessão quando nulo. */
export const numeroOuTraco = (valor: number | null | undefined): string =>
  valor === null || valor === undefined ? '—' : `${valor}`

/** Formata parcela (installmentNumber) — sem total, só o número. */
export const formatarParcela = (
  installmentNumber: number | null | undefined
): string =>
  installmentNumber === null || installmentNumber === undefined
    ? '—'
    : `${installmentNumber}`

const CLOUDWATCH_REGION = 'us-east-1'
const CLOUDWATCH_LOG_GROUP = '/ecs/prod-services'
/** Janela relativa do Logs Insights, em segundos (12h). */
const CLOUDWATCH_RANGE_SEGUNDOS = 43200

/**
 * Encoding do "editorString" do CloudWatch Logs Insights: cada caractere fora de
 * [A-Za-z0-9] vira `*` + hex (2 dígitos) do code point. O próprio `*` vira `*2a`.
 */
const encodeEditorString = (texto: string): string =>
  texto.replace(/[^A-Za-z0-9]/g, c => {
    const hex = c.charCodeAt(0).toString(16).padStart(2, '0')
    return `*${hex}`
  })

/**
 * Monta a URL do CloudWatch Logs Insights já com a query dos erros da execução
 * (filtrada por ExecutionId), abrindo na janela das últimas 12h.
 */
export const montarUrlCloudWatch = (
  executionId: string,
  apenasErros = false
): string => {
  const filtroResultado = apenasErros ? ` and Properties.Result='Error'` : ''

  const query = [
    `fields @timestamp, Level, coalesce(Properties.ServiceName, Properties.NomeServico) as Servico, Properties.Result, @message, Exception`,
    `| filter Properties.ExecutionId='${executionId}'${filtroResultado}`,
    `| sort @timestamp desc`
  ].join('\n')

  const detalhe =
    `(end~0~start~-${CLOUDWATCH_RANGE_SEGUNDOS}~timeType~'RELATIVE` +
    `~tz~'UTC~unit~'seconds~editorString~'${encodeEditorString(query)}` +
    `~source~(~'${encodeEditorString(CLOUDWATCH_LOG_GROUP)})` +
    `~lang~'CWLI~logClass~'STANDARD~queryBy~'logGroupName)`

  return (
    `https://${CLOUDWATCH_REGION}.console.aws.amazon.com/cloudwatch/home` +
    `?region=${CLOUDWATCH_REGION}#logsV2:logs-insights` +
    `$3FqueryDetail$3D~${detalhe}`
  )
}
